import React, { PropsWithChildren } from "react";
import styled, { css } from "styled-components";

interface Props {
    centerContent?: boolean;
    backgroundImage?: string;
    children: React.ReactNode;
}

const Main = (props: PropsWithChildren<Props>) => (
    <Wrapper
        background={props.backgroundImage}
        centerContent={props.centerContent}>
        {props.children}
    </Wrapper>
);

export default Main;

const Wrapper = styled.div<{ centerContent?: boolean; background?: string }>`
    width: 100%;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: ${({ centerContent }) => (centerContent ? "100vh" : "0")};

    ${({ background }) =>
        background?.length &&
        css`
            background-image: url(${background});
            background-size: cover;
            background-position: center;
        `};

    ${({ centerContent }) =>
        centerContent &&
        css`
            align-items: center;
            justify-content: center;
        `}
`;
